import React from "react";
import ButtonSecondary from "../buttons/ButtonSecondary";

const ModalConfirm = ({
  isOpen,
  closeModal,
  titleModal,
  textModal,
  textButton,
  classButton,
}) => {
  const handleCancel = () => {
    closeModal();
  };
  const handleUpdate = () => {
    closeModal();
  };

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
      <div className="bg-white p-8 rounded-lg mx-6 max-w-[500px]">
        <h2 className="text-h6 text-dark4 mb-4 text-center">{titleModal}</h2>
        <p className="text-bodyMR text-dark4 text-center mb-2">{textModal}</p>
        <p className="text-bodyMR text-dark4 text-center mb-4">
          This action is irreversible.
        </p>
        <div className="flex justify-center mt-6 space-x-4">
          <ButtonSecondary
            text={textButton || "Discard"}
            customClass="bg-redDark text-white text-bodyMR px-[22px] py-[10px]"
            onClick={handleUpdate}
          />
          <ButtonSecondary
            text="Cancel"
            customClass="bg-white text-dark4 text-bodyMR border border-dark4 px-[22px] py-[10px]"
            onClick={handleCancel}
          />
        </div>
      </div>
    </div>
  );
};

export default ModalConfirm;
